function zeroNullFilterer(dataObject) {
  if (dataObject.totalValue) return dataObject;
  return undefined;
}

export default zeroNullFilterer;
